import type { ReactNode } from 'react';
import styles from './StatusChip.module.css';

/**
 * Status-Chip (UX-Plan Phase 2.5). Farbe = Dringlichkeit:
 * ok = nichts zu tun · warn = fehlt noch / Entwurf · action = Handlung nötig · neutral = Info.
 */
export type StatusChipTone = 'ok' | 'warn' | 'action' | 'neutral';

interface StatusChipProps {
  tone: StatusChipTone;
  children: ReactNode;
  title?: string;
  className?: string;
}

export default function StatusChip({ tone, children, title, className }: StatusChipProps) {
  return (
    <span className={`${styles.chip} ${styles[tone]} ${className ?? ''}`} title={title}>
      {children}
    </span>
  );
}
